@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import uz.mint.frontend.components.layouts.MarkdownLayout as _uz_mint_frontend_components_layouts_MarkdownLayout
import uz.mint.frontend.components.layouts.PageLayout as _uz_mint_frontend_components_layouts_PageLayout
import uz.mint.frontend.pages.EsimsRoutePage as _uz_mint_frontend_pages_EsimsRoutePage
import uz.mint.frontend.pages.FaqPage as _uz_mint_frontend_pages_FaqPage
import uz.mint.frontend.pages.HomePage as _uz_mint_frontend_pages_HomePage
import uz.mint.frontend.pages.LoginRoutePage as _uz_mint_frontend_pages_LoginRoutePage
import uz.mint.frontend.pages.OfferPage as _uz_mint_frontend_pages_OfferPage
import uz.mint.frontend.pages.OrderRoutePage as _uz_mint_frontend_pages_OrderRoutePage
import uz.mint.frontend.pages.PlansPage as _uz_mint_frontend_pages_PlansPage
import uz.mint.frontend.pages.PrivacyPage as _uz_mint_frontend_pages_PrivacyPage
import uz.mint.frontend.pages.ProfileRoutePage as _uz_mint_frontend_pages_ProfileRoutePage
import uz.mint.frontend.pages.en.EnEsimsRoutePage as _uz_mint_frontend_pages_en_EnEsimsRoutePage
import uz.mint.frontend.pages.en.EnLoginRoutePage as _uz_mint_frontend_pages_en_EnLoginRoutePage
import uz.mint.frontend.pages.en.EnOrderRoutePage as _uz_mint_frontend_pages_en_EnOrderRoutePage
import uz.mint.frontend.pages.en.EnProfileRoutePage as _uz_mint_frontend_pages_en_EnProfileRoutePage
import uz.mint.frontend.pages.en.EnglishFaqPage as _uz_mint_frontend_pages_en_EnglishFaqPage
import uz.mint.frontend.pages.en.EnglishHomePage as _uz_mint_frontend_pages_en_EnglishHomePage
import uz.mint.frontend.pages.en.EnglishOfferPage as _uz_mint_frontend_pages_en_EnglishOfferPage
import uz.mint.frontend.pages.en.EnglishPlansPage as _uz_mint_frontend_pages_en_EnglishPlansPage
import uz.mint.frontend.pages.en.EnglishPrivacyPage as _uz_mint_frontend_pages_en_EnglishPrivacyPage
import uz.mint.frontend.pages.uz.UzEsimsRoutePage as _uz_mint_frontend_pages_uz_UzEsimsRoutePage
import uz.mint.frontend.pages.uz.UzLoginRoutePage as _uz_mint_frontend_pages_uz_UzLoginRoutePage
import uz.mint.frontend.pages.uz.UzOrderRoutePage as _uz_mint_frontend_pages_uz_UzOrderRoutePage
import uz.mint.frontend.pages.uz.UzProfileRoutePage as _uz_mint_frontend_pages_uz_UzProfileRoutePage
import uz.mint.frontend.pages.uz.UzbekFaqPage as _uz_mint_frontend_pages_uz_UzbekFaqPage
import uz.mint.frontend.pages.uz.UzbekHomePage as _uz_mint_frontend_pages_uz_UzbekHomePage
import uz.mint.frontend.pages.uz.UzbekOfferPage as _uz_mint_frontend_pages_uz_UzbekOfferPage
import uz.mint.frontend.pages.uz.UzbekPlansPage as _uz_mint_frontend_pages_uz_UzbekPlansPage
import uz.mint.frontend.pages.uz.UzbekPrivacyPage as _uz_mint_frontend_pages_uz_UzbekPrivacyPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Mint.uz"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "uz.mint.frontend.components.layouts.MarkdownLayout",
            parentLayoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _uz_mint_frontend_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "uz.mint.frontend.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _uz_mint_frontend_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_HomePage()
        }
        ctx.router.register(
            "/en/",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.en.initEnglishHomePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_en_EnglishHomePage()
        }
        ctx.router.register(
            "/en/esims",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.en.initEnEsimsRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_en_EnEsimsRoutePage()
        }
        ctx.router.register(
            "/en/faq",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.en.initEnglishFaqPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_en_EnglishFaqPage()
        }
        ctx.router.register(
            "/en/login",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.en.initEnLoginRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_en_EnLoginRoutePage()
        }
        ctx.router.register(
            "/en/offer",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.en.initEnglishOfferPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_en_EnglishOfferPage()
        }
        ctx.router.register(
            "/en/order",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.en.initEnOrderRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_en_EnOrderRoutePage()
        }
        ctx.router.register(
            "/en/plans",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.en.initEnglishPlansPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_en_EnglishPlansPage()
        }
        ctx.router.register(
            "/en/privacy",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.en.initEnglishPrivacyPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_en_EnglishPrivacyPage()
        }
        ctx.router.register(
            "/en/profile",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.en.initEnProfileRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_en_EnProfileRoutePage()
        }
        ctx.router.register(
            "/esims",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.initEsimsRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_EsimsRoutePage()
        }
        ctx.router.register(
            "/faq",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.initFaqPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_FaqPage()
        }
        ctx.router.register(
            "/login",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.initLoginRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_LoginRoutePage()
        }
        ctx.router.register(
            "/offer",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.initOfferPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_OfferPage()
        }
        ctx.router.register(
            "/order",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.initOrderRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_OrderRoutePage()
        }
        ctx.router.register(
            "/plans",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.initPlansPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_PlansPage()
        }
        ctx.router.register(
            "/privacy",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.initPrivacyPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_PrivacyPage()
        }
        ctx.router.register(
            "/profile",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.initProfileRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_ProfileRoutePage()
        }
        ctx.router.register(
            "/uz/",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.uz.initUzbekHomePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_uz_UzbekHomePage()
        }
        ctx.router.register(
            "/uz/esims",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.uz.initUzEsimsRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_uz_UzEsimsRoutePage()
        }
        ctx.router.register(
            "/uz/faq",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.uz.initUzbekFaqPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_uz_UzbekFaqPage()
        }
        ctx.router.register(
            "/uz/login",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.uz.initUzLoginRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_uz_UzLoginRoutePage()
        }
        ctx.router.register(
            "/uz/offer",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.uz.initUzbekOfferPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_uz_UzbekOfferPage()
        }
        ctx.router.register(
            "/uz/order",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.uz.initUzOrderRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_uz_UzOrderRoutePage()
        }
        ctx.router.register(
            "/uz/plans",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.uz.initUzbekPlansPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_uz_UzbekPlansPage()
        }
        ctx.router.register(
            "/uz/privacy",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.uz.initUzbekPrivacyPage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_uz_UzbekPrivacyPage()
        }
        ctx.router.register(
            "/uz/profile",
            layoutId = "uz.mint.frontend.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                uz.mint.frontend.pages.uz.initUzProfileRoutePage(ctx)
            },
        ) { pageCtx -> 
            _uz_mint_frontend_pages_uz_UzProfileRoutePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("markdown", uz.mint.frontend.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("shell", uz.mint.frontend.ShellStyle)
        ctx.theme.registerStyle("eyebrow", uz.mint.frontend.EyebrowStyle)
        uz.mint.frontend.initColorMode(ctx)
        uz.mint.frontend.initStyles(ctx)
        uz.mint.frontend.initSiteStyles(ctx)
        uz.mint.frontend.initTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        uz.mint.frontend.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
